export default "__VITE_ASSET__Ce6jf_0U__"